import {Box, styled} from "@mui/material"

const StyledFormItemWrapper = styled(Box)(() => ({
  width: '100%',
}))
const StyledLabel = styled(Box)(() => ({
  fontSize: '13px',
  fontWeight: 400,
  lineHeight: '20px',
  marginBottom: '6px'
}))

export default function FormItem({label, children}) {
  return <StyledFormItemWrapper>
    {label && <StyledLabel className="text-ellipsis">{label}</StyledLabel>}
    {children}
  </StyledFormItemWrapper>
}